// Angular
import { Component, ElementRef, ViewChild } from '@angular/core';
import { SharedService } from '../../../../shared/sharedServices/shared.service';
import { HecResponse } from '../../../../shared/shared-interfaces/hecResponse';
import { HEC_CONSTANTS } from '../../../../utilities/constants';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'kt-topbar',
	templateUrl: './topbar.component.html',
	styleUrls: ['./topbar.component.scss'],
})
export class TopbarComponent { 
	public notificationList:any;
	public showiFrame:boolean = false;
	public personalData:any;
	public minimize:boolean = false;
	@ViewChild('tleft',{static:false}) public tooltip: NgbTooltip;
	@ViewChild('iframe',{static:false}) iframe: ElementRef
	constructor(private sharedService:SharedService){
		// this.getNotificationsList();
		this.getPersonalDetails();
	}

	ngAfterViewInit() {
		this.tooltip.open();
	}

	public getNotificationsList(page):void {
		let data= 
			{"data":["DAS","DES"]}
		this.sharedService.getAllNotificationsByAcronyms(page,data).subscribe(
			(res:HecResponse)=>{
				if(res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK){
					this.notificationList = res.data;
				}
			}
		)
	}

	public gotoHelp():void{
		window.open('https://onlinehelp.hec.gov.pk/')
	}

	public downloadPageManual(): void {
		window.open('./assets/manuals/' + 'Portal-Manual.pdf')
	
	  }

	public goToChat():void{
		this.showiFrame = true;
		this.minimize = true;
		this.iframe.nativeElement.setAttribute('src', `https://webchatcrm.com/Client.aspx?s=104&w=1&name=${this.personalData.personalDetail.fullName}&phone=${this.personalData.personalDetail.cellPhone}&cnic=${this.personalData.authenticationName}&email=${this.personalData.email}`);
	}

	public dismiss(){
		this.minimize = !this.minimize;
	}

	public getPersonalDetails(){
		this.sharedService.getPersonalDetails().subscribe(
		  (res)=>{
			if(res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK){
			  this.personalData = res.data;
			}
		  }
		)
		window.scroll(0,0)
	
	  }
}
